<template>
    <div class="UpdateDateControl" style="width:140px;float:right; ">
        <a href="javascript:void(0)" style="font-family:HelveticaNeue" v-on:mouseenter="updateToggle(true, $event)" v-on:mouseleave="updateToggle(false, $event)">
            LastUpdateTime
        </a>
        <div ref="divLastUpdateTime" class="LastUpdateContainer" :class="{hidden:this.IsShowUpdate===false}">
            <div class="UpdateTime">
                <div v-for="dw in UpdateDateList" class="UpdateTimeSpan">
                    {{dw.UpdateDate}}
                    <br/>{{dw.UpdateTime}}
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.LastUpdateContainer {
  position: absolute;
  width: 231px;
  height: 410px;
  background-image: url(../assets/img/UpdateTime.png);
  -webkit-filter: drop-shadow(1px 1px 2px #222);
  filter: drop-shadow(1px 1px 2px #222);
  font-family: HelveticaNeue;
  z-index: 1000;
}

.LastUpdateContainer .UpdateTime {
  margin-top: 94px;
  margin-left: 30px;
  font-family: "HelveticaNeue";
}

.UpdateDateControl a {
  background-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  color: #4a4a4a;
  cursor: auto;
  display: inline;
  font-family: "HelveticaNeueBold";
  font-size: 15px;
  height: auto;
  line-height: 22.5px;
  text-decoration: underline;
  width: auto;
}

.UpdateDateControl a:hover div {
  border-bottom-color: #0086e5;
}

.UpdateTimeSpan {
  font-size: 21px;
  margin-bottom: 63px;
}
</style>
<script>
export default {
  props: ["UpdateDateList"],
  data() {
    return {
      IsShowUpdate: false
    };
  },
  methods: {
    updateToggle: function(isShow, event) {
      this.IsShowUpdate = isShow;
      let x = event.clientX - 100;
      let y = event.clientY + 10;
      this.$refs.divLastUpdateTime.style.left = x + "px";
      this.$refs.divLastUpdateTime.style.top = y + "px";
    }
  }
};
</script>



// WEBPACK FOOTER //
// UpdateDate.vue?379b4c0e